<div class="lead-alert-modal"
     [class.phase-ringing]="callPhase() === 'ringing'"
     [class.phase-accepted]="callPhase() === 'accepted'"
     [class.phase-connecting]="callPhase() === 'connecting'"
     [class.phase-declined]="callPhase() === 'declined'">

  <!-- NEW LEAD BANNER -->
  <div class="new-lead-banner">
    <mat-icon class="pulse-icon">fiber_new</mat-icon>
    <span class="banner-text">NEW LEAD</span>
  </div>

  <!-- Header -->
  <div class="header">
    <div class="alert-icon-wrapper">
      <mat-icon class="alert-icon">campaign</mat-icon>
    </div>
    <h2 class="title">Lead Alert</h2>
    <p class="subtitle">A new lead requires your attention</p>
  </div>

  <!-- Lead Card -->
  <div class="lead-card">
    <div class="avatar-section">
      <div class="avatar" [class.animated]="callPhase() === 'ringing'">
        {{ getInitials() }}
      </div>
      <div class="status-badge">New</div>
    </div>

    <div class="lead-details">
      <h3 class="lead-name">{{ leadInfo()?.name || 'Unknown Lead' }}</h3>
      <p class="lead-phone">
        <mat-icon>phone</mat-icon>
        {{ leadInfo()?.phone || 'No phone' }}
      </p>
    </div>

    <!-- Context Tags -->
    <div class="context-tags">
      @if (leadInfo()?.programName) {
        <span class="tag program">
          <mat-icon>school</mat-icon>
          {{ leadInfo()?.programName }}
        </span>
      }
      @if (leadInfo()?.campusName) {
        <span class="tag campus">
          <mat-icon>location_on</mat-icon>
          {{ leadInfo()?.campusName }}
        </span>
      }
      @if (leadInfo()?.ownerName) {
        <span class="tag owner">
          <mat-icon>person</mat-icon>
          {{ leadInfo()?.ownerName }}
        </span>
      }
    </div>
  </div>

  <!-- Status Section -->
  <div class="status-section">
    <div class="status-message" [class]="callPhase()">
      @switch (callPhase()) {
        @case ('ringing') {
          <div class="ring-animation"></div>
          <span>{{ statusMessage() }}</span>
        }
        @case ('accepted') {
          <mat-spinner diameter="20"></mat-spinner>
          <span>{{ statusMessage() }}</span>
        }
        @case ('connecting') {
          <mat-spinner diameter="20"></mat-spinner>
          <span>{{ statusMessage() }}</span>
        }
        @case ('declined') {
          <mat-icon>call_end</mat-icon>
          <span>{{ statusMessage() }}</span>
        }
      }
    </div>

    <!-- Ring Timer -->
    @if (callPhase() === 'ringing') {
      <div class="ring-timer">{{ formattedRingDuration() }}</div>
    }
  </div>

  <!-- Action Buttons -->
  <div class="actions-section">
    <!-- Ringing Phase: Accept/Decline (single action for WebRTC) -->
    @if (callPhase() === 'ringing') {
      <div class="action-buttons">
        <button mat-fab extended color="primary" class="answer-btn"
                (click)="answerAlert()" [disabled]="isProcessing()">
          <mat-icon>check_circle</mat-icon>
          Accept & Call
        </button>
        <button mat-fab extended color="warn" class="decline-btn"
                (click)="declineLead()" [disabled]="isProcessing()">
          <mat-icon>close</mat-icon>
          Pass
        </button>
      </div>
    }
  </div>
</div>
